import api from './api'

const getUserData = () => api.get('/UsuarioSISU')

const create = (data) => api.post('/UsuarioSISU', data)

const update = (data) => api.put('/UsuarioSISU', data)

const login = (data) => api.post('/UsuarioSISU/Login', data)

const forgotPassword = (data) => api.post('/UsuarioSISU/EsqueciMinhaSenha', data)

const changePassword = (guid, data) => api.post(`/UsuarioSISU/RedefinirSenha/${guid}`, data)

const deleteUser = () => api.delete('/UsuarioSISU')

export const UsersService = {
  getUserData,
  create,
  update,
  login,
  forgotPassword,
  deleteUser,
  changePassword,
}
